module.exports = __webpack_public_path__ + "static/media/img_arrow_bottom.f58033f0.svg";